import { BarChartHorizontalIcon, Building2 } from "lucide-react";
import { Outlet } from "react-router-dom";

import { SecondaryNavigation } from "@/components/secondary-navigation";
import { NavigationGroup } from "@/types/navigation";

export function SuperAdminLayout() {
  const navigation: NavigationGroup[] = [
    {
      name: "Super Admin",
      icon: Building2,
      elements: [
        { name: "Organisations", href: "/admin/organisations" },
        { name: "Users", href: "/admin/users" },
        { name: "Invitations", href: "/admin/invitations" },
        { name: "Sessions", href: "/admin/sessions" },
        { name: "Room Systems", href: "/admin/room-systems" },
        { name: "Recordings", href: "/admin/recordings" },
      ],
    },
    {
      name: "Platform Controls",
      icon: Building2,
      elements: [{ name: "Announcements", href: "/admin/announcements" }],
    },
    {
      name: "Reporting",
      icon: BarChartHorizontalIcon,
      elements: [
        { name: "Overview", href: "/admin/reporting/overview" },
        {
          name: "Organisations & Groups",
          href: "/admin/reporting/organisations",
        },
        {
          name: "Room Systems",
          href: "/admin/reporting/room-systems",
        },
        {
          name: "Replay",
          href: "/admin/reporting/replay",
        },
      ],
    },
  ];

  return (
    <div className="grid grid-cols-12 gap-x-8">
      <div className="hidden md:col-span-3 md:block">
        <SecondaryNavigation navigations={navigation} />
      </div>
      <div className="col-span-12 md:col-span-9">
        <Outlet />
      </div>
    </div>
  );
}
